import React, { useState, useEffect, useRef } from 'react';
import { stats } from '../data/mock';

const CountUp = ({ end, duration = 2000, suffix = '' }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const endValue = parseInt(end.replace(/[^0-9]/g, ''));
    const increment = endValue / (duration / 16);
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= endValue) {
        setCount(endValue);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, end, duration]);

  return (
    <span ref={elementRef}>
      {count}
      {suffix}
    </span>
  );
};

const Stats = () => {
  const statItems = [
    { value: stats.clients, label: 'Trusted Clients', color: 'from-purple-500 to-blue-500', suffix: '+' },
    { value: stats.reviews, label: 'Positive Reviews', color: 'from-blue-500 to-cyan-500', suffix: '+' },
    { value: stats.replyRate, label: 'Reply Rate', color: 'from-purple-500 to-pink-500', suffix: '%' }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-900 to-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {statItems.map((stat, index) => (
            <div
              key={index}
              className="text-center group hover:scale-105 transition-transform duration-300"
            >
              <div className="relative inline-block">
                <h3
                  className={`text-6xl font-bold bg-gradient-to-r ${stat.color} bg-clip-text text-transparent mb-2`}
                >
                  <CountUp end={stat.value} duration={2000} suffix={stat.suffix} />
                </h3>
                <div className={`absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r ${stat.color} rounded-full mx-auto`} style={{width: '60%', margin: '0 auto'}}></div>
              </div>
              <p
                className="text-xl text-gray-400 font-medium mt-4"
                style={{ letterSpacing: '0.1em' }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;